import { makeUseAxios } from "axios-hooks";

import { getBaseStore } from "@utils/configuration/aem";

import { ExtendedUseAxios, createApiFor } from "./utils";

const useCartServiceApi = makeUseAxios({
    axios: createApiFor(`/cartservice/${getBaseStore()}`),
    defaultOptions: {
        ssr: false,
        manual: false,
    },
}) as ExtendedUseAxios;

const useBFFCartServiceApi = makeUseAxios({
    axios: createApiFor(`/${getBaseStore()}`, { bff: true }),
    defaultOptions: {
        ssr: false,
        manual: false,
    },
}) as ExtendedUseAxios;

export { useCartServiceApi, useBFFCartServiceApi };
